<template>
  <div class="slider">
    <p v-html="surveyQuestion.longCaption" class="slider-title"></p>
    <div class="slider-content">
      <div v-if="initialState">
        <img
          class="slider-swipe-img"
          src="../../../assets/slider-swipe-instruction.svg"
          alt="swipe instructions"
        />
        <p class="slider-inital">{{ texts.slider_label }}</p>
      </div>
      <div v-else class="slider-smiley">
        <img :src="smileyAssets" alt="smiley rating" />
      </div>
    </div>
    <div class="row slider-description">
      <p class="negative-description">{{ negativeLabel }}</p>
      <p class="positive-description">{{ positiveLabel }}</p>
    </div>
    <div class="slider-container">
      <input
        v-model="sliderValue"
        ref="sliderInput"
        type="range"
        min="0"
        :max="max"
        class="slider"
        @input="onInput"
        @change="onInput"
        step="0.1"
      />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters, mapActions } = createNamespacedHelpers('survey')

export default {
  name: 'Slider',
  data() {
    return {
      sliderValue: this.max / 2,
      initialState: true,
      ratingChosen: false,
      imageName: 'smiley_5.svg',
      roundValue: 0,
    }
  },
  created() {
    this.setInputName(this.surveyQuestion.inputName)
    this.$emit('setValid', false)
    this.roundValue = Math.round(this.sliderValue)
  },
  computed: {
    ...mapGetters(['surveyQuestion', 'texts']),
    negativeLabel() {
      return this.surveyQuestion.responses[0].caption
    },
    positiveLabel() {
      const { responses } = this.surveyQuestion
      return responses[responses.length - 1].caption
    },
    isSlider10() {
      return this.surveyQuestion.type === 'SLIDER10'
    },
    smileyAssets() {
      return require(`../../../assets/smiley/${this.imageName}`)
    },
    max() {
      return this.isSlider10 ? 9 : 10
    },
  },
  methods: {
    ...mapActions(['setInputName', 'setAnswer']),
    onInput() {
      this.initialState = false
      this.$emit('setValid', true)
      this.roundValue = Math.round(this.sliderValue)
      this.changeSmiley(this.roundValue)
      this.setAnswer(this.surveyQuestion.responses[this.roundValue].id)
    },
    changeSmiley(value) {
      const sliderResource = this.isSlider10 ? value + 1 : value
      this.imageName = `smiley_${sliderResource}.svg`
    },
  },
}
</script>

<style scoped lang="postcss">
.slider {
  &-title {
    font-family: 'Open Sans', sans-serif;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    font-size: 25px;
    line-height: 1.2;
    text-align: left;
    letter-spacing: normal;
    color: #191919;
  }

  @media (max-width: 768px) {
    &-title {
      padding-top: 10px;
      font-size: 16px;
    }

    &-description {
      margin-bottom: 20px;

      .negative-description {
        width: 100%;
        margin: 0 10px 10px 0;
        text-align: left;
      }

      .positive-description {
        width: 100%;
        margin: 0 10px 10px 0;
        text-align: right;
      }
    }
  }

  &-inital {
    font-weight: normal;
    font-size: 16px;
    line-height: 1.33;
    color: #d7d7d7;
  }

  &-description {
    display: flex;
    font-size: 16px;
    line-height: 0.94;
    color: #191919;
    justify-content: space-between;
    margin-bottom: 5px;
  }

  &-description p:first-letter {
    text-transform: capitalize;
  }

  &-content {
    margin: 25px;
    height: 120px;
    font-size: 120px;
    font-weight: bold;
    line-height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-swipe-img {
    display: block;
    margin: 0 auto;
  }

  &-smiley {
    height: 100px;
    width: 100px;
    position: relative;
    border: none !important;

    img {
      border: none !important;
    }
  }

  &-container {
    background-color: white;
    margin: 0;
    text-align: center;

    .slider {
      -webkit-appearance: none;
      width: 100%;
      height: 9px;
      background: #d7d7d7;
      outline: none;
      -webkit-transition: 0.2s;
      transition: opacity 0.2s;
    }

    .slider::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 40px;
      height: 40px;
      background-image: url('../../../assets/circle-carets.svg');
      background-color: #ffffff;
      cursor: pointer;
      border: none;
    }

    .slider::-moz-range-thumb {
      width: 40px;
      height: 40px;
      background-image: url('../../../assets/circle-carets.svg');
      background-color: #ffffff;
      cursor: pointer;
      border: none;
    }
  }
}
</style>
